import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { WebToolsMenu } from 'src/app/_models/WebTools';
import { AuthenticationService } from '../../auth/services/authentication.service';
import { BrazeService } from 'src/app/services/braze.service';
import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ModalboxComponent } from '../modalbox/modalbox.component';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'web-tools-menu',
  templateUrl: './web-tools-menu.component.html',
  styleUrls: ['./web-tools-menu.component.scss'],
  providers: [],
})
export class WebToolsMenuComponent implements OnInit, OnDestroy {
  isOpen: boolean;
  closeDelayMs = 900;
  timeout: ReturnType<typeof setTimeout>;
  private sm = new SubscriptionManager();
  licensedApps$: Observable<WebToolsMenu[]>;
  unlicensedApps$: Observable<WebToolsMenu[]>;
  expiredApps$: Observable<WebToolsMenu[]>;
  menu$: Observable<WebToolsMenu[]>;
  subscriptionManager = new SubscriptionManager();
  constructor(
    private brazeService: BrazeService,
    private service: AuthenticationService,
    private modalService: BsModalService,
    private routeService: RouteService
  ) {
    this.isOpen = false;
  }
  ngOnInit() {
    this.menu$ = this.service.getLicensedApps().pipe(
      map((apps) =>
        apps.map((app) => ({
          ...app,
          imageSource: `../assets/img/${app.imageSource}`,
          showUnlicensedMessage: false,
          name: app.name.replace(/^ALK /, '').replace(/^CoPilot /, ''),
        }))
      ),
      shareReplay(1)
    );
    this.unlicensedApps$ = this.menu$.pipe(
      map((projects) => projects.filter((app) => !app.licensed && !app.expired))
    );
    this.licensedApps$ = this.menu$.pipe(
      map((projects) => projects.filter((app) => app.licensed && !app.expired))
    );
    this.expiredApps$ = this.menu$.pipe(
      map((projects) => projects.filter((app) => app.expired))
    );
    this.sm.manage = this.licensedApps$.subscribe((data) => {
      const productLicense = data?.find(
        (products) => products?.name.toString() === 'ContentTools'
      );
      localStorage.setItem(
        'isLicensedContentTools',
        productLicense ? 'true' : 'false'
      );
    });
  }
  toggleCard() {
    this.isOpen = !this.isOpen;
  }
  closeCard() {
    this.isOpen = false;
  }
  cancelClose() {
    clearTimeout(this.timeout);
  }
  logout() {
    if (this.checkSavedRoutes()) {
      this.proceedToLogout();
    } else {
      this.showDialog();
    }
  }
  delayedCloseCard() {
    this.timeout = setTimeout(() => {
      this.closeCard();
    }, this.closeDelayMs);
  }
  toggleUnlicensedProductInfo(product: WebToolsMenu, event: Event): void {
    product.showUnlicensedMessage = !product.showUnlicensedMessage;
    event.stopPropagation();
    event.preventDefault();
  }
  goToAppPage(product: WebToolsMenu) {
    this.brazeService.trackAppChange(product);
    this.isOpen = false;
    window.open(product.homeUrl, '_blank');
  }
  showDialog() {
    const initialState = {
      title: 'Unsaved Routes',
      list: ['You have unsaved changes that will be lost if you continue.'],
      actionButtonText: 'Continue',
      btnClass: 'btn btn-primary',
    };
    const dialogRef = this.modalService.show(ModalboxComponent, {
      initialState,
      ignoreBackdropClick: true,
      keyboard: false,
      animated: true,
      class: 'modal-dialog-centered',
    });

    this.subscriptionManager.manage = dialogRef.content.event.subscribe(() => {
      this.proceedToLogout();
    });
  }

  checkSavedRoutes(): boolean {
    const routes = this.routeService.getStorage();
    return !routes?.routeList.some(
      (route) => route?.savedId === null && route?.stopsState.length > 0
    );
  }
  proceedToLogout() {
    this.routeService.clearStorage();
    this.brazeService.trackLogout();
    this.service.logout();
  }
  ngOnDestroy(): void {
    this.subscriptionManager.unsubscribe();
  }
}
